//DATA STORES
//DATA STORES
const stores = [
  {
    "store": "Abra Cadabra – Botafogo (Rio Sul)",
    "address": "Rua Lauro Muller, 116 - Loja D76AB - 4º Piso - Botafogo",
    "city": "Rio de Janeiro",
    "uf": "RJ",
    "zip": "22290-160",
    "code": ["21"],
    "phone": ["971096119"],
    "horario": ["Segunda a Sábado, das 10h00 às 22h00", "Domingo e Feriados, das 13h00 às 21h00"],
    "site": "https://www.abracadabra.com.br/",
    "instagram": "https://www.instagram.com/abracadabraoficial/",
    "services": ["Estacionamento", "Wi-Fi", "Acessibilidade", "Ponto de Táxi"]
  },
  {
    "store": "Abra Cadabra – Icaraí",
    "address": "Rua Miguel Frias, 112 - Icaraí",
    "city": "Niterói",
    "uf": "RJ",
    "zip": "24220-003",
    "code": ["21"],
    "phone": ["971094173"],
    "horario": ["Segunda a Sexta-feira, das 10h00 às 19h00", "Sábado, das 10h00 às 16h00"],
    "site": "https://www.abracadabra.com.br/",
    "instagram": "https://www.instagram.com/abracadabraoficial/",
    "services": []
  },
  {
    "store": "Abra Cadabra – Via Parque",
    "address": "Avenida Ayrton Senna, 3000 - 1º Piso - Loja 1120",
    "city": "Rio de Janeiro",
    "uf": "RJ",
    "zip": "22775-904",
    "code": ["21"],
    "phone": ["967306805"],
    "horario": ["Segunda a Sábado, das 10h00 às 22h00", "Domingo e Feriados, das 13h00 às 21h00"],
    "site": "https://www.abracadabra.com.br/",
    "instagram": "https://www.instagram.com/abracadabraoficial/",
    "services": ["Estacionamento", "Bicicletário", "Fraldário", "Wi-Fi", "Acessibilidade"]
  },
  {
    "store": "Abraço de Mãe",
    "address": "Rua Senador Joaquim Pedro Salgado Filho, 296 - São Bento",
    "city": "Bento Gonçalves",
    "uf": "RS",
    "zip": "95703-156",
    "code": ["54"],
    "phone": ["991555231"],
    "horario": ["Segunda a Sexta-feira, das 09h30 às 11h45 e das 13h15 às 18h30", "Sábado, das 09h00 às 15h00"],
    "site": "https://www.dombebe.com.br/",
    "instagram": "https://www.instagram.com/lojadombebe",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Alô Bebê",
    "address": "Avenida Ibirapuera, 2726",
    "city": "São Paulo",
    "uf": "SP",
    "zip": "04029-200",
    "code": ["11"],
    "phone": ["943150741"],
    "horario": ["Segunda a Sábado, das 10h00 às 19h00", "Domingo, das 11h00 às 17h00", "Feriados, consulte horário de atendimento pelo telefone da loja"],
    "site": "https://www.alobebe.com.br/",
    "instagram": "https://www.instagram.com/alobebeoficial/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Amura Baby",
    "address": "Rua Correia de Melo, 118 - Bom Retiro",
    "city": "São Paulo",
    "uf": "SP",
    "zip": "01123-020",
    "code": ["11"],
    "phone": ["953090845"],
    "horario": ["Segunda a Sábado, das 08h00 às 18h00", "Domingo, das 09h00 às 16h00"],
    "site": "https://amurababy.com.br/",
    "instagram": "https://www.instagram.com/amurababy/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Amura Baby",
    "address": "Alameda dos Maracatins, 1023 - Indianópolis",
    "city": "São Paulo",
    "uf": "SP",
    "zip": "04089-013",
    "code": ["11"],
    "phone": ["953090845"],
    "horario": ["Segunda a Sábado, das 09h00 às 18h00", "Domingo, das 09h00 às 16h00"],
    "site": "https://amurababy.com.br/",
    "instagram": "https://www.instagram.com/amurababy/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Amura Baby",
    "address": "Rua Maria Marcolina, 118 - Brás",
    "city": "São Paulo",
    "uf": "SP",
    "zip": "03011-000",
    "code": ["11"],
    "phone": ["944582188"],
    "horario": ["Segunda a Sábado, das 08h00 às 18h00", "Domingo, das 09h00 às 16h00"],
    "site": "https://amurababy.com.br/",
    "instagram": "https://www.instagram.com/amurababy/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Anjinhos Baby Store",
    "address": "Rua Marcílio Dias, 1326 - Loja 07 - Centro",
    "city": "Novo Hamburgo",
    "uf": "RS",
    "zip": "93510-368",
    "code": ["51"],
    "phone": ["996174440"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 19h00", "Sábado, das 09h00 às 18h00", "Domingo, Fechado"],
    "site": "https://www.anjinhosbabystore.com.br/",
    "instagram": "https://www.instagram.com/anjinhos.babystore/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Babaloo Baby Store",
    "address": "Avenida Brasil, 7181 - Centro",
    "city": "Cascavel",
    "uf": "PR",
    "zip": "85801-001",
    "code": ["45"],
    "phone": ["998067620"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h30", "Sábado, das 09h00 às 16h00", "Domingo, Fechado"],
    "site": "https://babaloobabys.store/",
    "instagram": "https://www.instagram.com/babaloocascavel/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Baby",
    "address": "Avenida Rondon Pacheco, 4840 - Tibery",
    "city": "Uberlândia",
    "uf": "MG",
    "zip": "38405-142",
    "code": ["34"],
    "phone": ["32361122"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h00", "Sábado, das 09h00 às 13h00"],
    "site": "",
    "instagram": "https://www.instagram.com/babyuberlandia/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Baby Buys",
    "address": "Rua Santa Justina, 449 - Vila Olímpia",
    "city": "São Paulo",
    "uf": "SP",
    "zip": "04545-042",
    "code": ["11"],
    "phone": ["994593702"],
    "horario": ["Segunda a Sexta-feira, das 10h00 às 18h00", "Sábado, das 10h00 às 16h00"],
    "site": "https://www.babybuysbrasil.com.br/",
    "instagram": "https://www.instagram.com/babybuysbrasil",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Baby Center RP",
    "address": "Rua Couto Magalhães, 150 - Subsetor Sul - 5 (S-5)",
    "city": "Ribeirão Preto",
    "uf": "SP",
    "zip": "14025-690",
    "code": ["16"],
    "phone": ["996175037"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h00", "Sábado, das 09h00 às 15h00"],
    "site": "https://www.babycenternet.com.br/",
    "instagram": "https://www.instagram.com/babycenterribeirao/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Baby Dreams",
    "address": "Avenida Deputado Jamel Cecílio, 1399 - Quadra F42A - Lote 49 - Setor Sul",
    "city": "Goiânia",
    "uf": "GO",
    "zip": "74085-580",
    "code": ["62"],
    "phone": ["35462146"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h00", "Sábado, das 09h00 às 13h00"],
    "site": "https://babydreamsgoiania.com.br/",
    "instagram": "https://www.instagram.com/babydreamsgoiania/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Baby Dreams",
    "address": "Avenida T-12, 76 - Setor Bueno",
    "city": "Goiânia",
    "uf": "GO",
    "zip": "74223-080",
    "code": ["62"],
    "phone": ["30924442"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h00", "Sábado, das 09h00 às 13h00"],
    "site": "https://babydreamsgoiania.com.br/",
    "instagram": "https://www.instagram.com/babydreamsgoiania/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Baby Vindo",
    "address": "Rua Vereador João Angelino Lopes Júnior, 178 - Centro",
    "city": "Itajaí",
    "uf": "SC",
    "zip": "88301-230",
    "code": ["47"],
    "phone": ["992534877"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h30", "Sábado, das 09h00 às 13h00"],
    "site": "https://www.babyvindo.com.br/",
    "instagram": "https://www.instagram.com/lojababyvindoitj/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Bebê Veste Bem",
    "address": "Rua Mantena, 54 - Ouro Preto",
    "city": "Belo Horizonte",
    "uf": "MG",
    "zip": "31310-430",
    "code": ["31"],
    "phone": ["33173205"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 19h00", "Sábado, das 09h00 às 17h00", "Domingo, Fechado"],
    "site": "https://www.bebevestebem.com.br/",
    "instagram": "https://www.instagram.com/bebevestebem/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Bebeco",
    "address": "Rua Coronel Procópio Gomes de Oliveira, 481 - Centro",
    "city": "Jaraguá do Sul",
    "uf": "SC",
    "zip": "89251-201",
    "code": ["47"],
    "phone": ["992047755"],
    "horario": ["Segunda a Sexta-feira, das 09h30 às 18h30", "Sábado e Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/bebecomamaesebebes/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Bicho Papão",
    "address": "Rua Santa Justina, 479 - Vila Olímpia",
    "city": "São Paulo",
    "uf": "SP",
    "zip": "04545-042",
    "code": ["11"],
    "phone": ["989279593"],
    "horario": ["Segunda a Sexta-feira, das 09h30 às 18h00", "Sábado, das 10h00 às 16h00"],
    "site": "https://www.bichopapao.com.br/",
    "instagram": "https://www.instagram.com/lojasbichopapao",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Bicho Papão",
    "address": "Avenida Rebouças, 2201 - Pinheiros",
    "city": "São Paulo",
    "uf": "SP",
    "zip": "05401-300",
    "code": ["11"],
    "phone": ["989279593"],
    "horario": ["Segunda a Sexta-feira, das 09h30 às 18h00", "Sábado, das 10h00 às 16h00"],
    "site": "https://www.bichopapao.com.br/",
    "instagram": "https://www.instagram.com/lojasbichopapao",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Bicho Papão",
    "address": "Avenida Doutor Hermas Braga, 328 - Nova Campinas",
    "city": "Campinas",
    "uf": "SP",
    "zip": "13092-133",
    "code": ["19"],
    "phone": ["991330110"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h00", "Sábado, das 09h00 às 14h00"],
    "site": "https://www.bichopapao.com.br/",
    "instagram": "https://www.instagram.com/lojasbichopapao",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Cia das Fraldas",
    "address": "Rua Dois de Setembro, 4096 - Itoupava Norte",
    "city": "Blumenau",
    "uf": "SC",
    "zip": "89053-200",
    "code": ["47"],
    "phone": ["991257656"],
    "horario": ["Segunda a Sexta-feira, das 08h30 às 18h00", "Sábado, das 08h30 às 13h00", "Domingo, Fechado"],
    "site": "http://www.ciadasfraldas.com.br/",
    "instagram": "https://www.instagram.com/ciadasfraldasblumenau",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Coisas de Mamãe",
    "address": "Rua Paes Leme, 25 - Centro",
    "city": "Brusque",
    "uf": "SC",
    "zip": "88350-220",
    "code": ["47"],
    "phone": ["991600030"],
    "horario": ["Segunda a Sexta-feira, das 08h00 às 12h00 e das 13h30 às 18h00", "Sábado, das 08h30 às 12h30", "Domingo, Fechado"],
    "site": "https://www.lojacoisasdemamae.com.br/",
    "instagram": "https://www.instagram.com/coisas_demamae/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "diBebê Concept",
    "address": "Avenida Doutor Nilo Peçanha, 2577 - Petrópolis",
    "city": "Porto Alegre",
    "uf": "RS",
    "zip": "91330-001",
    "code": ["51"],
    "phone": ["992438321"],
    "horario": ["Segunda a Sábado, das 10h00 às 18h30", "Domingo, das 12h00 às 17h00"],
    "site": "https://dibebeloja.com.br/",
    "instagram": "https://www.instagram.com/dibebeconcept/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Encanto Enxovais",
    "address": "Rua Presidente Kennedy, 171 - Jardim América",
    "city": "Rio do Sul",
    "uf": "SC",
    "zip": "89160-190",
    "code": ["47"],
    "phone": ["996511300"],
    "horario": ["Segunda a Sexta-feira, das 08h30 às 12h00 e das 13h30 às 18h30", "Sábado, das 08h30 às 12h30", "Domingo, Fechado"],
    "site": "https://www.encantoenxovais.com.br/",
    "instagram": "https://www.instagram.com/encantoenxovais/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Fralda & Cia",
    "address": "Rua Amadeu Segundo Cherubine, 560 - Vila São Manoel",
    "city": "São José do Rio Preto",
    "uf": "SP",
    "zip": "15091-250",
    "code": ["17"],
    "phone": ["35130242"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h00", "Sábado, das 09h00 às 14h00", "Domingo, Fechado"],
    "site": "https://www.fraldaecia.com.br/",
    "instagram": "https://www.instagram.com/fraldaeciarp/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "GeorgiaBaby",
    "address": "Rua Brusque, 60 - Centro",
    "city": "Itajaí",
    "uf": "SC",
    "zip": "88303-000",
    "code": ["47"],
    "phone": ["30454546"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h30", "Sábado, das 09h00 às 13h00", "Domingo, Fechado"],
    "site": "https://www.georgiababy.com.br/",
    "instagram": "https://www.instagram.com/georgiababysc/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "GeorgiaBaby",
    "address": "Avenida 3ª Avenida, 185 - Centro",
    "city": "Balneário Camboriú",
    "uf": "SC",
    "zip": "88330-083",
    "code": ["47"],
    "phone": ["988130724"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h30", "Sábado, das 09h00 às 13h00", "Domingo, Fechado"],
    "site": "https://www.georgiababy.com.br/",
    "instagram": "https://www.instagram.com/georgiababysc/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Heylulibaby",
    "address": "Avenida Afonso Pena, 4909 - Shopping Campo Grande (em frente à Biscoite) - Santa Fé",
    "city": "Campo Grande",
    "uf": "MS",
    "zip": "79031-010",
    "code": ["67"],
    "phone": ["991940548"],
    "horario": ["Segunda a Sábado, das 10h00 às 22h00", "Domingo, das 12h00 às 20h00"],
    "site": "https://www.heylulibaby.com.br/",
    "instagram": "https://www.instagram.com/heylulibaby",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Heylulibaby",
    "address": "Avenida Oito de Abril, 204 - Sala 3 - Popular",
    "city": "Cuiabá",
    "uf": "MT",
    "zip": "78045-380",
    "code": ["65"],
    "phone": ["993241500"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h00", "Sábado, das 09h00 às 14h00", "Domingo, Fechado"],
    "site": "https://www.heylulibaby.com.br/",
    "instagram": "https://www.instagram.com/heylulibaby",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Heylulibaby",
    "address": "Avenida José Munia, 5535 - Sala 3 - Jardim Redentor",
    "city": "São José do Rio Preto",
    "uf": "SP",
    "zip": "15085-350",
    "code": ["17"],
    "phone": ["991335812"],
    "horario": ["Segunda a Sábado, das 10h00 às 22h00", "Domingo, das 14h00 às 20h00"],
    "site": "https://www.heylulibaby.com.br/",
    "instagram": "https://www.instagram.com/heylulibaby",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Juju Bebê",
    "address": "Largo da Boa Morte, 156 - Centro",
    "city": "Limeira",
    "uf": "SP",
    "zip": "13480-188",
    "code": ["19"],
    "phone": ["37130234"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h00", "Sábado, das 09h00 às 14h00", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/jujubebebabyshop/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Locomotiva Baby",
    "address": "Avenida João Valério, 930 - Lote Jardim Amazônia - Nossa Senhora das Graças",
    "city": "Manaus",
    "uf": "AM",
    "zip": "69053-140",
    "code": ["92"],
    "phone": ["35844386"],
    "horario": ["Segunda a Sábado, das 08h30 às 18h30", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/locomotivababyoficial/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Lua de Papel Baby Kids",
    "address": "Avenida Madre Benvenuta, 809 - Santa Mônica",
    "city": "Florianópolis",
    "uf": "SC",
    "zip": "88035-000",
    "code": ["48"],
    "phone": ["30286897"],
    "horario": ["Segunda a Sábado, das 09h00 às 19h00", "Domingo, Fechado"],
    "site": "https://www.luadepapel.com.br/",
    "instagram": "https://www.instagram.com/luadepapelbabykids/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Mais Baby",
    "address": "Avenida Godofredo Maciel, 2575 - Maraponga",
    "city": "Fortaleza",
    "uf": "CE",
    "zip": "60712-023",
    "code": ["85"],
    "phone": ["991513928"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 19h00", "Sábado, das 09h00 às 18h00", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/lojasmaisbaby",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Mamãe Bebê",
    "address": "CRS 510 - Bloco B - Loja 11 - Asa Sul",
    "city": "Brasília",
    "uf": "DF",
    "zip": "70360-525",
    "code": ["61"],
    "phone": ["999344332"],
    "horario": ["Segunda a Sábado, das 09h00 às 18h00", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/mamaebebe.df/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Encanto",
    "address": "SHCS CRS 510 - Asa Sul",
    "city": "Brasília",
    "uf": "DF",
    "zip": "70360-515",
    "code": ["61"],
    "phone": ["999180889"],
    "horario": ["Segunda a Sábado, das 09h00 às 18h00", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/encanto.brasilia/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Incantare",
    "address": "Avenida Juscelino Kubitschek, 856 - Centro",
    "city": "Foz do Iguaçu",
    "uf": "PR",
    "zip": "85851-210",
    "code": ["45"],
    "phone": ["35278500"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h00", "Sábado, das 09h00 às 13h00", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/incantare_bebe/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Meu Bebê",
    "address": "Rua Quinze de Novembro, 740 - Centro",
    "city": "Joinville",
    "uf": "SC",
    "zip": "89201-600",
    "code": ["47"],
    "phone": ["992759477"],
    "horario": ["Segunda a Sexta-feira, das 09h30 às 18h00", "Sábado, das 09h00 às 13h00"],
    "site": "https://meubebeprime.com.br/",
    "instagram": "https://www.instagram.com/meubebejoinville/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Meu Bebê Exclusive",
    "address": "Rua Otto Boehm, 972 - América",
    "city": "Joinville",
    "uf": "SC",
    "zip": "89201-700",
    "code": ["47"],
    "phone": ["999862232"],
    "horario": ["Segunda a Sexta-feira, das 09h30 às 18h30", "Sábado, das 09h00 às 13h00", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/meubebeexclusive/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Tip Top Mega Store – Belém",
    "address": "Avenida Gentil Bittencourt, 775 - Nazaré",
    "city": "Belém",
    "uf": "PA",
    "zip": "66040-172",
    "code": ["91"],
    "phone": ["935009384"],
    "horario": ["Segunda a Sábado, das 09h00 às 19h00", "Domingo, das 10h00 às 14h00"],
    "site": "https://www.tiptop.com.br/",
    "instagram": "https://www.instagram.com/tiptopmegastore_br/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Tip Top Mega Store – Jardim Pamplona Shopping",
    "address": "Rua Pamplona, 1704 - Loja LUC 2.21 - Piso 2 - Jardim Paulista",
    "city": "São Paulo",
    "uf": "SP",
    "zip": "01405-002",
    "code": ["11"],
    "phone": ["992230627"],
    "horario": ["Segunda a Sábado, das 10h00 às 22h00", "Domingo, das 14h00 às 20h00"],
    "site": "https://www.tiptop.com.br/",
    "instagram": "https://www.instagram.com/tiptopmegastore_br/",
    "services": ["Bicicletário", "Carregador de carros elétricos", "Fraldário", "Espaço Kids"]
  },
  {
    "store": "Tip Top Mega Store – Shopping ABC",
    "address": "Avenida Pereira Barreto, 42 - Piso P2 - Loja 412 A - Paraíso (Shopping ABC)",
    "city": "Santo André",
    "uf": "SP",
    "zip": "09190-210",
    "code": ["11"],
    "phone": ["28664350"],
    "horario": ["Segunda a Sábado, das 10h00 às 22h00", "Domingo e Feriados, das 14h00 às 20h00"],
    "site": "https://www.tiptop.com.br/",
    "instagram": "https://www.instagram.com/tiptopmegastore_br/",
    "services": ["Estacionamento", "Acessibilidade", "Wi-Fi", "Fraldário"]
  },
  {
    "store": "Tip Top Mega Store – Shopping da Ilha",
    "address": "Avenida Daniel de La Touche, 987 - Loja 304 F/G/H - Cohama",
    "city": "São Luís",
    "uf": "MA",
    "zip": "65074-115",
    "code": ["98"],
    "phone": ["988352606"],
    "horario": ["Segunda a Sábado, das 10h00 às 22h00", "Domingo e Feriados, das 13h00 às 21h00"],
    "site": "https://www.tiptop.com.br/",
    "instagram": "https://www.instagram.com/tiptopmegastore_br/",
    "services": ["Estacionamento", "Espaço Família", "Bicicletário", "Wi-Fi"]
  },
  {
    "store": "TotalBaby Store",
    "address": "Rua Professor Oswaldo Teixeira, 369 - Vila Progredior",
    "city": "São Paulo",
    "uf": "SP",
    "zip": "05617-020",
    "code": ["11"],
    "phone": ["27785590"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 17h00", "Sábado, das 10h00 às 17h00"],
    "site": "https://www.totalbabystore.com.br/",
    "instagram": "https://www.instagram.com/totalbabystore",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Tutus Baby",
    "address": "Praça San Martin, 84 - Loja 01 - Praia do Canto",
    "city": "Vitória",
    "uf": "ES",
    "zip": "29055-170",
    "code": ["27"],
    "phone": ["996889816"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h30", "Sábado, das 09h00 às 14h00", "Domingo, Fechado"],
    "site": "https://www.tutusbaby.com.br/",
    "instagram": "https://www.instagram.com/tutusbabybr/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Varejão Baby",
    "address": "Rua Lobo D'Almada, 92 - Centro",
    "city": "Manaus",
    "uf": "AM",
    "zip": "69010-030",
    "code": ["92"],
    "phone": ["992135465"],
    "horario": ["Segunda a Sexta-feira, das 08h30 às 17h00", "Sábado, das 08h30 às 16h00", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/varejaobaby/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "San Remo Baby",
    "address": "Rua Professora Severina de Sousa Souto, 157 - Jardim Oceania",
    "city": "João Pessoa",
    "uf": "PB",
    "zip": "58037-070",
    "code": ["83"],
    "phone": ["32457567"],
    "horario": ["Segunda a Sexta-feira, das 08h30 às 18h00", "Sábado, das 08h40 às 16h30", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/sanremobaby/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Casulo | Móveis Infantis",
    "address": "Avenida das Embaúbas, 1142 A - Centro",
    "city": "Sinop",
    "uf": "MT",
    "zip": "78550-084",
    "code": ["66"],
    "phone": ["996257523"],
    "horario": ["Segunda a Sexta-feira, das 08h00 às 18h00", "Sábado, das 08h00 às 12h00", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/moveisinfantiscasulo/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Baby Shop Linhares",
    "address": "Avenida Hans Schmoger, 212 - Conceição",
    "city": "Linhares",
    "uf": "ES",
    "zip": "29900-495",
    "code": ["27"],
    "phone": ["997404908"],
    "horario": ["Segunda a Sexta-feira, das 08h30 às 18h00", "Sábado, das 08h30 às 12h30", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/babyshop.linhares/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Lívia Baby – Maringá",
    "address": "Rua Santos Dumont, 2125 - Zona 01",
    "city": "Maringá",
    "uf": "PR",
    "zip": "87013-050",
    "code": ["44"],
    "phone": ["32272858"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h00", "Sábado, das 09h00 às 13h00", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/liviababymaringa/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Vivi Carrinhos de Bebê",
    "address": "Edifício Paramount - Avenida República Argentina, 357 - Conjunto 06 - Água Verde",
    "city": "Curitiba",
    "uf": "PR",
    "zip": "80240-210",
    "code": ["41"],
    "phone": ["995407682"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h00", "Sábado, das 10h00 às 15h00", "Domingo, Fechado"],
    "site": "http://www.vivicarrinhosdebebe.com/",
    "instagram": "https://www.instagram.com/vivicarrinhosdebebe/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Mundo da Cegonha",
    "address": "Rua Júlio Prestes, 275 - Vila Oliveira",
    "city": "Mogi das Cruzes",
    "uf": "SP",
    "zip": "08780-110",
    "code": ["11"],
    "phone": ["43129606"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h00", "Sábado, das 09h30 às 15h00", "Domingo, Fechado"],
    "site": "https://www.mundodacegonha.com.br/",
    "instagram": "https://www.instagram.com/lojamundodacegonha/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Balloon Store",
    "address": "Rua Santos Dumont, 2502 - Zona 03",
    "city": "Maringá",
    "uf": "PR",
    "zip": "87013-050",
    "code": ["44"],
    "phone": ["30250280"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h00", "Sábado, das 09h00 às 13h00", "Domingo, Fechado"],
    "site": "https://www.lojasballoon.com.br/",
    "instagram": "https://www.instagram.com/lojasballoon/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Domi Nick",
    "address": "Rua Almirante Barroso, 2018 - Sala 1 - Centro",
    "city": "Toledo",
    "uf": "PR",
    "zip": "85900-020",
    "code": ["45"],
    "phone": ["999204900"],
    "horario": ["Segunda a Sexta-feira, das 09h30 às 18h00", "Sábado, das 09h00 às 16h00", "Domingo, Fechado"],
    "site": "https://www.lojadominick.com.br/",
    "instagram": "https://www.instagram.com/lojadominick/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Saut Kids",
    "address": "Rua Doutor Luiz Bastos do Prado, 2195 - Centro",
    "city": "Gravataí",
    "uf": "RS",
    "zip": "94010-021",
    "code": ["51"],
    "phone": ["985809543"],
    "horario": ["Segunda a Sábado, das 09h00 às 18h30", "Domingo, Fechado"],
    "site": "https://sautkids.lojavirtualnuvem.com.br/",
    "instagram": "https://www.instagram.com/sautkids/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "A Caçulinha",
    "address": "Avenida Getúlio Dorneles Vargas, 2444 - Passo dos Fortes",
    "city": "Chapecó",
    "uf": "SC",
    "zip": "89805-060",
    "code": ["49"],
    "phone": ["33232487"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h30", "Sábado, das 08h30 às 17h00", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/caculinhachapeco/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Kangoo Baby & Kids",
    "address": "Rua Emiliano Ramos, 253 - Centro",
    "city": "Lages",
    "uf": "SC",
    "zip": "88502-215",
    "code": ["49"],
    "phone": ["999906905"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 19h00", "Sábado, das 09h00 às 17h00", "Domingo, Fechado"],
    "site": "https://kangoobaby.com.br/",
    "instagram": "https://www.instagram.com/kangoobabyoficial/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Ducarrinhos Carrinho de Bebê",
    "address": "Avenida Pedro Viriato Parigot de Souza, 164 - Loja 7 - Manella",
    "city": "Cambé",
    "uf": "PR",
    "zip": "86185-020",
    "code": ["43"],
    "phone": ["988243538"],
    "horario": ["Segunda a Sexta-feira, das 10h00 às 19h00", "Sábado, das 10h00 às 16h00", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/ducarrinhos_carrinhosdebebe/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Naju Baby",
    "address": "Rua Jeribá, 825 - Sala 3 - Chácara Cachoeira",
    "city": "Campo Grande",
    "uf": "MS",
    "zip": "79040-120",
    "code": ["67"],
    "phone": ["992276774"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h00", "Sábado, das 09h00 às 13h00", "Domingo, Fechado"],
    "site": "https://www.najubaby.com.br/",
    "instagram": "https://www.instagram.com/comnajubaby/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Abra Cadabra – Pinheiros",
    "address": "Rua Teodoro Sampaio, 1312 - Pinheiros",
    "city": "São Paulo",
    "uf": "SP",
    "zip": "05406-100",
    "code": ["11"],
    "phone": ["930636723"],
    "horario": ["Segunda a Sábado, das 10h00 às 20h00", "Domingo, das 11h00 às 17h00"],
    "site": "https://www.abracadabra.com.br/",
    "instagram": "https://www.instagram.com/abracadabraoficial/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Abra Cadabra – Anália Franco",
    "address": "Rua Emília Marengo, 305 - 2º Piso - Jardim Anália Franco",
    "city": "São Paulo",
    "uf": "SP",
    "zip": "03336-000",
    "code": ["11"],
    "phone": ["968402748"],
    "horario": ["Segunda a Sábado, das 10h00 às 19h00", "Domingo, Fechado"],
    "site": "https://www.abracadabra.com.br/",
    "instagram": "https://www.instagram.com/abracadabraoficial/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Baby Chérie",
    "address": "Avenida Rio Branco, 1281 - Praia do Canto",
    "city": "Vitória",
    "uf": "ES",
    "zip": "29055-643",
    "code": ["27"],
    "phone": ["999187718"],
    "horario": ["Segunda a Sexta-feira, das 09h30 às 19h00", "Sábado, das 09h30 às 17h30", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/babycheriestore/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Nana Nenê",
    "address": "Quadra 104 Sul, Rua SE 11, Lote 25 - Conjunto 3 - Plano Diretor Sul",
    "city": "Palmas",
    "uf": "TO",
    "zip": "77020-026",
    "code": ["63"],
    "phone": ["32153010"],
    "horario": ["Segunda a Sexta-feira, das 08h30 às 18h30", "Sábado, das 08h30 às 13h30", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/nananene_infantil/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Adoleta Baby",
    "address": "Avenida Carlos Gomes, 2242 - São Cristóvão",
    "city": "Porto Velho",
    "uf": "RO",
    "zip": "76804-038",
    "code": ["69"],
    "phone": ["992597485"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 18h30", "Sábado, das 09h00 às 18h00", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/adoletababypvh/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Fino Trato Kids",
    "address": "Avenida Getúlio Vargas, 4491 - São Pedro",
    "city": "Boa Vista",
    "uf": "RR",
    "zip": "69306-700",
    "code": ["95"],
    "phone": ["981154079"],
    "horario": ["Segunda a Sábado, das 09h00 às 19h00", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/finotratokids/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Baby Mania",
    "address": "Avenida Ruben Bento Alves, 1698 - Jardim América",
    "city": "Caxias do Sul",
    "uf": "RS",
    "zip": "95032-050",
    "code": ["54"],
    "phone": ["32028275"],
    "horario": ["Segunda a Sábado, das 09h00 às 19h00", "Domingo, das 14h00 às 19h00"],
    "site": "",
    "instagram": "https://www.instagram.com/lojababymania/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Mimontic",
    "address": "Avenida Iguaçu, 2940 - Água Verde",
    "city": "Curitiba",
    "uf": "PR",
    "zip": "80240-031",
    "code": ["41"],
    "phone": ["999920300"],
    "horario": ["Segunda a Sexta-feira, das 10h00 às 18h00", "Sábado, das 10h00 às 14h00", "Domingo, Fechado"],
    "site": "http://mimontic.com.br/",
    "instagram": "https://www.instagram.com/mimontic_curitiba/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Bubi Bebê",
    "address": "Rua Estevão de Mendonça, 500 - Popular",
    "city": "Cuiabá",
    "uf": "MT",
    "zip": "78045-420",
    "code": ["65"],
    "phone": ["993104040"],
    "horario": ["Segunda a Sexta-feira, das 08h00 às 19h00", "Sábado, das 08h00 às 18h00", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/bubibebebrasil/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Baby Dreams Santos",
    "address": "Rua Pereira Barreto, 37 - Gonzaga",
    "city": "Santos",
    "uf": "SP",
    "zip": "11065-110",
    "code": ["13"],
    "phone": ["997078161"],
    "horario": ["Segunda a Sábado, das 10h00 às 18h00", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/babydreamssantos/",
    "services": ["Estacionamento", "Fraldário"]
  },
  {
    "store": "Mundo do Bebê",
    "address": "Rua Morom, 920 - Vila Popular",
    "city": "Passo Fundo",
    "uf": "RS",
    "zip": "99010-030",
    "code": ["54"],
    "phone": ["996995391"],
    "horario": ["Segunda a Sexta-feira, das 09h00 às 11h30 e das 14h00 às 18h00", "Sábado, das 09h30 às 11h45 e das 13h30 às 15h45", "Domingo, Fechado"],
    "site": "",
    "instagram": "https://www.instagram.com/mundodobebe_pf/",
    "services": ["Estacionamento", "Fraldário"]
  }
]

let getSstates = () => {
  let uf = []

  for (let s in stores) {
    uf.push(stores[s].uf)
  }
  let states = uf.filter(function(el, i) {
      return uf.indexOf(el) === i;
  });

  states.sort()
  listStates(states)
}

let listStates = (uf) => {
  let selectUF = document.getElementById('uf-state')
  
  for (let i in uf) {
    let option = document.createElement('option')
    
    option.innerText = uf[i]
    option.setAttribute('value', uf[i])
    selectUF.appendChild(option)
  }

  // DEFAULT: selecionar SP se existir
  (function selectSPIfExists() {
    var hasSP = false
    for (var i = 0; i < selectUF.options.length; i++) {
      if (selectUF.options[i].value === 'SP') { hasSP = true; break }
    }
    if (hasSP) { selectUF.value = 'SP' }
  })();

  let ufSelected = selectUF.value

  getCities(ufSelected, stores)

  selectUF.addEventListener('change', function(){
    getCities(this.value, stores)
  })
}

let getCities = (val, stores) => {
  let citiesList = stores.filter( el => el.uf == val)
  let city = []

  for (let u in citiesList) {
    city.push(citiesList[u].city)  
  }
  
  let cities = city.filter(function(el, i) {
      return city.indexOf(el) === i;
  });

  cities.sort()
  listCities(cities)
}

let listCities = (cities) => {
  let selectCity = document.getElementById('uf-city')

  selectCity.innerHTML = ''

  for (c in cities) {
    let option = document.createElement('option')
    option.innerText = cities[c]
    option.setAttribute('value', cities[c])
    selectCity.appendChild(option)
  }

  // DEFAULT: se existir, selecionar "São Paulo" (ou "Sao Paulo")
  ;(function selectSaoPauloIfExists(){
    var target = ['São Paulo','Sao Paulo']
    var foundIndex = -1
    for (var i = 0; i < selectCity.options.length; i++) {
      var val = selectCity.options[i].value
      if (target.indexOf(val) > -1) { foundIndex = i; break }
    }
    if (foundIndex > -1) { selectCity.selectedIndex = foundIndex }
  })();

  getStores(selectCity.value)
}

let getStores = (val) => {
  const locals = stores
    .filter(el => el.city === val)
    .sort((a, b) => {
      const A = (a.store || '').toString();
      const B = (b.store || '').toString();
      return A.localeCompare(B, 'pt-BR', { sensitivity: 'base' });
    });
  let setStores = document.querySelector('.stores')
  
  setStores.innerHTML = ''
  
  for (let l in locals) {
    let storeLocal = document.createElement('div')

    storeLocal.classList.add('col')
    
    storeLocal.innerHTML = `
      <div class="card h-100">
        <div class="card-body">
          <h5 class="card-title fs-2">${locals[l].store}</h5>
          <div class="row align-items-center justify-content-evenly">
            <div class="col">
              <p class="card-text text-body-secondary mb-1">
                <span class="fw-bold">Endereço:</span>
                ${locals[l].address}, ${locals[l].city} - ${locals[l].uf}, ${locals[l].zip}
                <a href="javascript:void(0)" onclick="storeClick(this.dataset)" data-address="${locals[l].store} ${locals[l].address}, ${locals[l].city} - ${locals[l].uf}, ${locals[l].zip}, Brasil">ver mapa</a>
              </p>
              <p class="card-text text-body-secondary mb-1">
                <span class="fw-bold">Horário de Funcionamento:</span>
                <br>
                ${locals[l].horario.length > 0 ? locals[l].horario.join('<br>') : 'Horário não informado'}
              </p>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col">
              <p class="card-text text-body-secondary">
                <span class="fw-bold">Telefone:</span>
                ${
                  locals[l].phone && locals[l].phone.length > 0 && locals[l].phone[0] !== ""
                    ? locals[l].phone.map((phone, idx) => {
                        const code = locals[l].code && locals[l].code[idx] ? locals[l].code[idx] : locals[l].code[0] || "";
                        return `<a href="tel:${code}${phone.replace(/\D/g, '')}" class="link-offset-2 link-underline link-underline-opacity-0">
                          (${code}) ${phone}
                        </a>`;
                      }).join(' | ')
                    : 'Telefone não informado'
                }
                <br>
                <a href="${locals[l].site}" target="_blank"
                  class="link-offset-2 link-underline link-underline-opacity-0" style="color: #426e90;">
                  <i class="fa-solid fa-square-up-right fs-4"></i>
                </a>
                <a href="${locals[l].instagram}" target="_blank"
                  class="link-offset-2 link-underline link-underline-opacity-0" style="color: #426e90;">
                  <i class="fa-brands fa-square-instagram fs-4"></i>
                </a>
              </p>
            </div>
          </div>
          <div class="row align-items-center justify-content-evenly">
            <div class="col">
              <p class="card-text text-body-secondary mb-1">
                <span class="fw-bold">Serviços disponíveis:</span>
                <br>
                ${locals[l].services.length > 0 ? locals[l].services.map(service => `<span class="badge rounded-pill text-bg-success bg-opacity-50">${service}</span>`).join(' ') :
                `<span class="badge rounded-pill text-bg-secondary bg-opacity-50">Nenhum serviço informado</span>`}
              </p>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <small class="text-body-secondary">*Importante: Ligue antes de visitar</small>
        </div>
      </div>
    `
    setStores.appendChild(storeLocal)
  }
}

getSstates()

let mapSet = document.getElementById('mapFrame')
storeClick = (e) => {
  let storeMap = `https://maps.google.com/maps?hl=pt-BR&q=${e.address}&ie=UTF8&output=embed`
  mapSet.setAttribute('src', storeMap);
  mapSet.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
